module.exports = __webpack_public_path__ + "5d2121347c17efb532b172e088592ce6.svg";